import { Box, Dialog, DialogContent, DialogTitle, FormControl, Grid2, IconButton, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactElement, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import RedButton from "../../../Common/UI/components/RedButton";

export const CancelDialog = ({ handleClose, handleCancel }: { handleClose: () => void; handleCancel: (comment: string) => void }): ReactElement => {
  const [reason, setReason] = useState<string>("");
  const [reasonText, setReasonText] = useState<string>("");
  const REASONS = ["No Show", "Reschedule", "Other"];

  return (
    <Dialog
      open
      aria-hidden={false}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "350px",
            height: "auto",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <DialogTitle>Reason for Cancellation</DialogTitle>
        <IconButton
          size="small"
          disableRipple
          sx={{
            "&:hover": {
              border: "1px solid var(--bs-gray-400)",
              borderRadius: "5px",
            },
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Grid2 container justifyContent={"space-between"} rowSpacing={2}>
          <Grid2 size={12}>
            <FormControl sx={{ width: "100%" }}>
              <Select
                labelId="report-label"
                id="report-type"
                value={reason}
                onChange={(ev: SelectChangeEvent) => {
                  var r = ev.target.value as string;
                  if (r === REASONS[0] || r === REASONS[1]) {
                    setReason(r);
                    setReasonText(r);
                  } else if (r === REASONS[2]) {
                    setReason(r);
                    setReasonText("");
                  }
                }}
              >
                {REASONS.map((x) => (
                  <MenuItem key={x} value={x}>
                    {x}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          {reason === REASONS[2] ? (
            <Grid2 size={12}>
              <TextField
                multiline
                rows={4}
                variant="standard"
                className="txt-area"
                label="Reason"
                value={reasonText}
                onChange={(ev) => {
                  setReasonText(ev.target.value);
                }}
                sx={{ width: "100%" }}
              />
            </Grid2>
          ) : (
            <></>
          )}

          <Grid2 size={8}></Grid2>
          <Grid2 size={4} sx={{ textAlign: "right" }}>
            <RedButton
              onClick={() => {
                handleClose();
                handleCancel(reasonText);
              }}
              disabled={reasonText.length === 0}
              text={"OK"}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};
